import React from 'react';
import { Routes, Route } from 'react-router-dom';
import BugReportPage from './pages/BugReportPage';

export const BugReportRoutes: React.FC = () => {
  return (
    <Routes>
      <Route index element={<BugReportPage />} />
    </Routes>
  );
};
